import React from "react";
import { faceIcon, crossIcon } from "../../constants/Images";
import { useSelector } from "react-redux";

export default function BasicDetails() {
  const {profileData} = useSelector(state => state.authData);
  const {name, organization, email} = profileData || {}
  const {name: companyName } = organization || {}
  return (
    <div className="profileHeader userProfile">
      <div className="avatar_info">
        <div className="changeProfile">
          <img src={faceIcon} alt="Profile Avatar" className="profileImg" />
          <div className="profilechangeOverlaybox">
            <span className="text-white underline text-size-14 profilechangeOverlay">
              Change
            </span>
            <input type="file" className="choseProfileInput" />
          </div>
          <a href="#none" className="removeProfile">
            <img src={crossIcon} alt="remove" />
          </a>
        </div>
        <div className="ProfileInfo">
          <h2 className="profileName">
            {name} 
            {/* <span className="font-normal">White</span> */}
          </h2>
          <p className="profileDesc">
            {email} <br />
            {companyName}
          </p>
        </div>
      </div>
    </div>
  );
}
